import {Navigate, Route, Routes} from "react-router-dom";
import {Fragment, lazy, useEffect, useState} from "react";
import {REQ_TYPES, ROOT_URL} from "./constants/global";
import {fetchData} from "./helpers/general-functions";
import {useDispatch, useSelector} from "react-redux";
import {setLayout} from "./redux/slices/layout-slice";
import MainLayout from "./layouts/main-layout";
import {setActiveAccount} from "./redux/slices/user-slice";
import {SIDEBAR_ROUTES} from "./constants/routes";
import NotFound from "./pages/not-found";
import {toast} from "react-toastify";
import {Redirect, Splash} from "./components";

const PaymentResult = lazy(() => import("./pages/payment-result"));

function App() {

    const [isLoadedSplash, setIsLoadedSplash] = useState(false);
    const {isLoggedIn, activeAccount} = useSelector(state => state.user);
    const layout = useSelector(state => state.layout.data);
    const dispatch = useDispatch();

    useEffect(() => {
        (async () => {
            document.addEventListener('contextmenu', event => event.preventDefault());
            const layoutData = await fetchData("layout", REQ_TYPES.GET, {}, true);
            if (!layoutData.error) {
                try {
                    // dispatch(setActiveAccount(true));
                    if (layoutData.data.data.has_active_profession) {
                        dispatch(setActiveAccount(true));
                    }
                    dispatch(setLayout(layoutData.data.data));
                } catch (e) {
                    toast.error("خطا در بارگذاری اطلاعات")
                }
            }

            setIsLoadedSplash(true);
        })()
        // eslint-disable-next-line
    }, []);

    return (
        <>
            {
                isLoadedSplash ?
                    <Routes>
                        <Route path={ROOT_URL} element={<MainLayout/>}>
                            {
                                SIDEBAR_ROUTES.map(route => (
                                    <Fragment key={route.key}>
                                        {
                                            isLoggedIn && (route.activeInMenu === null || activeAccount) ?
                                                <>
                                                    {/* Main Route */}
                                                    <Route
                                                        index={!!route.index}
                                                        path={route.path}
                                                        element={route.element}
                                                    />
                                                    {
                                                        //Sub menu routes
                                                        route.subMenu.map(subMenuRoute => (
                                                            <Route
                                                                key={subMenuRoute.key}
                                                                path={subMenuRoute.path}
                                                                element={subMenuRoute.element}
                                                            />
                                                        ))
                                                    }
                                                </> :
                                                <Route
                                                    index={!!route.index}
                                                    path={route.path}
                                                    element={
                                                        isLoggedIn ?
                                                            <Navigate
                                                                to={layout?.professions_count ? `${ROOT_URL}/archive` : `${ROOT_URL}/add-expertise`}
                                                                replace
                                                            /> :
                                                            <Redirect url={process.env.REACT_APP_FREELANCER_LOGIN_URL}/>
                                                    }
                                                />
                                        }
                                    </Fragment>
                                ))
                            }
                        </Route>

                        <Route path={ROOT_URL + "/payment-result"} element={<PaymentResult/>}/>
                        <Route path="*" element={<NotFound/>}/>
                    </Routes> :
                    <Splash />
            }

        </>
    );
}

export default App;
